"use strict";
/* eslint-disable @typescript-eslint/no-unused-vars */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredPatientChats = void 0;
const models_1 = require("../../models");
const GroupChatInfoSocketUpdateObservable_1 = require("./GroupChatInfoSocketUpdateObservable");
const BaseGroupChats_1 = require("./BaseGroupChats");
const GroupChatMessageReadObservable_1 = require("./GroupChatMessageReadObservable");
const GroupChatSocketUpdateObservable_1 = require("./GroupChatSocketUpdateObservable");
const GroupChatSocketDeleteObservable_1 = require("./GroupChatSocketDeleteObservable");
const GroupChatUpdateAcknowledgementStatusObservable_1 = require("./GroupChatUpdateAcknowledgementStatusObservable");
const uuid_1 = require("uuid");
class FilteredPatientChats extends BaseGroupChats_1.BaseGroupChats {
    constructor(httpAdapter, organizationUser, socketAdapter, userDirectory, hhnStorage) {
        super(httpAdapter, organizationUser, socketAdapter, userDirectory, hhnStorage);
        this.isChatSearchCleared = false;
        this.removeListeners = [];
        this.changeListeners = [];
        this.isUpdatedSearch = (requestFilter, chatList) => {
            if (chatList.chatFilters) {
                return (JSON.stringify(requestFilter) !== JSON.stringify(chatList.chatFilters));
            }
            return false;
        };
        this.isPaginatedFilter = (chatList, requestFilter) => {
            if (!requestFilter && chatList.searchMatchCount) {
                return (chatList.hasNext && chatList.searchMatchCount > chatList.chats.length);
            }
            return false;
        };
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.socketAdapter = socketAdapter;
        this.userDirectory = userDirectory;
        this.hhnStorage = hhnStorage;
        this.groupChatUpdateAcknowledgementStatusObservable =
            new GroupChatUpdateAcknowledgementStatusObservable_1.GroupChatUpdateAcknowledgementStatusObservable(this.getChatsStorage(), organizationUser);
        this.groupChatMessageReadObservable = new GroupChatMessageReadObservable_1.GroupChatMessageReadObservable(this.getChatsStorage(), organizationUser);
        this.groupChatInfoSocketUpdateObservable =
            new GroupChatInfoSocketUpdateObservable_1.GroupChatInfoSocketUpdateObservable(this.getChatsStorage(), httpAdapter, organizationUser, socketAdapter, userDirectory);
        this.groupChatSocketUpdateObservable = new GroupChatSocketUpdateObservable_1.GroupChatSocketUpdateObservable(this.getChatsStorage(), httpAdapter, organizationUser, userDirectory);
        this.groupChatSocketDeleteObservable = new GroupChatSocketDeleteObservable_1.GroupChatSocketDeleteObservable(this.getChatsStorage(), organizationUser, hhnStorage);
    }
    destroy() {
        this.removeAllListeners();
    }
    init() {
        if (this.removeListeners && this.removeListeners.length > 0) {
            throw new Error("Panic: Listeners should have been destoryed during unmount!!!");
        }
        this.removeListeners.push(this.chatMessageReadListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.chatInfoUpdateListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.updateChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.markChatAsDeletedListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.updateChatAcknowledgementStatusListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.addAcknowledgementStatusToChatListener(() => {
            this.notifyChange();
        }));
    }
    registerChangeListener(cb) {
        const id = (0, uuid_1.v4)();
        this.changeListeners.push({ id, cb });
        return () => {
            this.changeListeners = this.changeListeners.filter(listner => listner.id !== id);
        };
    }
    notifyChange() {
        this.changeListeners.forEach(l => l.cb(this.getChats()));
    }
    removeAllListeners() {
        this.removeListeners.forEach(removeListener => removeListener());
        this.removeListeners = [];
    }
    chatMessageReadListener(cb) {
        return this.groupChatMessageReadObservable.chatMessageReadListener(cb, this.getChatType(), this.getGroupType());
    }
    chatInfoUpdateListener(cb) {
        return this.groupChatInfoSocketUpdateObservable.chatInfoUpdateListener(cb, this.getGroupType());
    }
    updateChatListener(cb) {
        return this.groupChatSocketUpdateObservable.updateChatListener(cb, this.getChatType(), this.getGroupType(), false);
    }
    markChatAsDeletedListener(cb) {
        return this.groupChatSocketDeleteObservable.markChatAsDeletedListener(cb, this.getGroupType(), this.getChatType());
    }
    getChatsStorage() {
        return this.hhnStorage.filteredChatsStorage;
    }
    getGroupType() {
        return models_1.GROUP_TYPE.PATIENT;
    }
    getChatType() {
        return models_1.CHAT_TYPE.GROUP;
    }
    filterChats(requestFilters, context) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const groupType = this.getGroupType();
            let chatList = this.getChats();
            const isNewSearch = (_a = ((requestFilters && !chatList.chatFilters) ||
                (requestFilters &&
                    this.isUpdatedSearch(requestFilters, chatList)))) !== null && _a !== void 0 ? _a : false;
            const isPaginatedFilter = this.isPaginatedFilter(chatList, requestFilters);
            if (isPaginatedFilter && !this.isChatSearchCleared) {
                // eslint-disable-next-line no-param-reassign
                requestFilters = chatList.chatFilters;
            }
            if (isNewSearch || this.isChatSearchCleared) {
                this.getChatsStorage().resetChatListByType(this.getGroupType());
                chatList = this.getChats();
                this.isChatSearchCleared = false;
            }
            if (chatList.hasNext) {
                const chatRequestBody = Object.assign(Object.assign({}, this.buildFetchChatsRequest(groupType)), (requestFilters && this.populateFilters(requestFilters)));
                yield this.fetchGroupChatList(chatRequestBody, groupType, requestFilters, context);
                this.notifyChange();
            }
        });
    }
    clearChatSearch() {
        this.isChatSearchCleared = true;
        this.filterChats();
    }
    populateFilters(chatFilters) {
        var _a;
        const validServices = (_a = chatFilters.servicesToPatient) === null || _a === void 0 ? void 0 : _a.filter(service => service &&
            service.id &&
            Object.values(models_1.SERVICE_STATUS).includes(service.status));
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (chatFilters.search && {
            search: `${chatFilters.searchTag || ""}${chatFilters.search}`,
        })), (chatFilters.patientStatus && {
            patientStatus: chatFilters.patientStatus,
        })), (validServices &&
            validServices.length > 0 && {
            servicesToPatient: validServices,
        })), (chatFilters.hiddenChats && {
            hiddenChats: chatFilters.hiddenChats,
        })), (chatFilters.filterBy && { filterBy: chatFilters.filterBy }));
    }
    getChats() {
        return this.getChatsStorage().getChatListByType(this.getGroupType());
    }
    updateChatAcknowledgementStatusListener(cb) {
        return this.groupChatUpdateAcknowledgementStatusObservable.updateChatAcknowledgementStatusListener(cb, this.getGroupType());
    }
    addAcknowledgementStatusToChatListener(cb) {
        return this.groupChatUpdateAcknowledgementStatusObservable.addAcknowledgementStatusToChatListener(cb, this.getGroupType(), this.organization.organizationId);
    }
}
exports.FilteredPatientChats = FilteredPatientChats;
